<div class="modal-header">
  <h4 class="modal-title pull-left">Modifica veicolo {{ plate }}</h4>
  <button
    type="button"
    class="btn-close close pull-right"
    aria-label="Close"
    (click)="bsModalRef.hide()"
  >
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div *ngIf="errorMessage" class="alert alert-danger my-3">
    {{ errorMessage }}
  </div>
  <p>Seleziona parco</p>
  <div class="form-group">
    <div class="form-check" *ngFor="let parkType of parkTypes">
      <input
        class="form-check-input"
        type="radio"
        id="{{ 'editVehicleParkType' + parkType['id'] }}"
        (change)="parkTypeChanged(parkType)"
        [checked]="parkType.id == foundParkTypeID"
        [value]="parkType.id"
        name="editVehicleTypeRadio"
      />
      <label
        class="form-check-label"
        for="{{ 'editVehicleParkType' + parkType['id'] }}"
      >
        {{ parkType["name"] }}
      </label>
    </div>
  </div>
  <div class="form-group">
    <label for="editVehicleParkSelect">Scegli il parco</label>
    <select
      class="form-control"
      id="editVehicleParkSelect"
      [(ngModel)]="selectedPark"
      (ngModelChange)="selectParkChange($event)"
    >
      <option *ngFor="let park of visibleParks" [ngValue]="park">
        {{ park["name"] }}
      </option>
    </select>
  </div>
  <mat-slide-toggle
    class="example-margin"
    color="primary"
    (change)="activeChecked = !activeChecked; didUserEdit = true"
    [checked]="activeChecked"
  >
    Attivo
  </mat-slide-toggle>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    (click)="onEditClick()"
    [disabled]="
      (!selectedParkType && !selectedPark) || !didUserEdit || isLoading
    "
  >
    <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1"></span
    >Effettua modifiche
  </button>
</div>
